import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { LineItemRow, type LineItemRowValue } from './LineItemRow'

interface SortableLineItemRowProps {
  id: string
  value: LineItemRowValue
  index: number
  currency: string
  errors: Record<string, string | undefined>
  onChange: (value: LineItemRowValue) => void
  onRemove: () => void
  isExpanded: boolean
  onToggleExpand: () => void
  isEditMode: boolean
}

export function SortableLineItemRow({
  id,
  value,
  index,
  currency,
  errors,
  onChange,
  onRemove,
  isExpanded,
  onToggleExpand,
  isEditMode,
}: SortableLineItemRowProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({
      id,
    })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : undefined,
  }

  return (
    <div ref={setNodeRef} style={style}>
      <LineItemRow
        value={value}
        index={index}
        currency={currency}
        errors={errors}
        onChange={onChange}
        onRemove={onRemove}
        isExpanded={isExpanded}
        onToggleExpand={onToggleExpand}
        isEditMode={isEditMode}
        dragListeners={listeners}
        dragAttributes={attributes}
      />
    </div>
  )
}
